const { jQuery: $ } = window;

export default class InPageNav {

    #theme;
    #$subNav;
    #isActive;

    /**
     * @param {Theme} theme
     */
    constructor(theme) {
        this.#$subNav = $(".inPageNav");
        this.#theme = theme;
        this.#isActive = false;
    }


    events() {
        const me = this;

        this.#$subNav.each(function (i, el) {

            $(el).find(".inPageNav__mobileNav").html($(el).find(".inPageNav__menu .inPageNav__button:first")[0].outerHTML);

            $(el).css("top", me.#theme.headerHeight + "px");

            $(window).on("resize", me.#theme.utils.debounce(1000, true, function() {
                $(el).css("top", me.#theme.headerHeight + "px");
            }));

            $(el).data("sticky", new Waypoint.Sticky({
                element: el,
                offset: me.#theme.headerHeight + "px"
            }));

            $(el).find(".inPageNav__menu .inPageNav__button").on("click", function () {
                const $btn = $(this);
                $(el).find(".inPageNav__mobileNav").removeClass("js-open");
                $(el).find(".inPageNav__menu").removeClass("js-open");

                setTimeout(function () {
                    $(el).find(".inPageNav__mobileNav").html($btn[0].outerHTML);
                    me.#$subNav.find(".inPageNav__button").removeClass("active");
                    $btn.addClass("active");
                }, me.#theme.scrollSpeed);
            });

            $(el).find(".inPageNav__mobileNav").on("click", function() {
                $(this).toggleClass("js-open");
                $(el).find(".inPageNav__menu").toggleClass("js-open");
            });
        });

        $(".builder-layout-anchor-section").each(function (i, el) {
            const target = $(el).find("[data-scroll]").attr("data-scroll");
            const $section = $(el).parents(".builder-section");

            me.#theme.utils.log("Found Anchor: ", target);

            $(el).data("inview", new Waypoint({
                element: $section,
                handler: function (dir) {
                    const $activeBtn = me.#$subNav.find(".inPageNav__button[data-target='" + target + "']");
                    const $subNav = $activeBtn.parents(".inPageNav"); // Current subnav

                    if ($activeBtn.length > 0) {
                        $subNav.removeClass("disabled");
                        $subNav.find(".inPageNav__button").removeClass("active");
                        $subNav.find(".inPageNav__mobileNav").html($activeBtn[0].outerHTML);
                        $activeBtn.addClass("active");
                        me.#isActive = true;
                    } else {
                        $subNav.addClass("disabled");
                        me.#isActive = false;
                    }
                },
                offset: me.#theme.headerHeight + me.height + "px"
            }));
        });
    }

    get height() {
        return this.#$subNav.height();
    }

    get isActive() {
        return this.#isActive;
    }
}